import styled from "styled-components";

export const StyledButton = styled.button`
  display: flex;
  padding: 15px !important;
  justify-content: center !important;
  align-items: center !important;
  border: 1px solid ${({ theme }) => theme.colors.dark} !important;
  color: ${({ theme }) => theme.colors.dark} !important;
  background: transparent !important;
  cursor: pointer !important;
  transition. 0.2s ease-in-out;
  white-space: wrap !important;
  &:hover{
    opacity: 0.7 !important;
  }
`;
